import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import { getUser } from '../auth';

export default function Admin() {
  const navigate = useNavigate();
  const user = getUser();
  const [activeTab, setActiveTab] = useState('dashboard');
  const [stats, setStats] = useState({});
  const [inscrits, setInscrits] = useState([]);
  const [activites, setActivites] = useState([]);
  const [signalements, setSignalements] = useState([]);
  const [pros, setPros] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { navigate('/connexion'); return; }
    fetchAll();
  }, []);

  const fetchAll = async () => {
    setLoading(true);
    const [
      { count: nbUsers },
      { count: nbActivites },
      { count: nbParticipations },
      { data: dernierInscrits },
      { data: dernieresActivites },
      { data: notifSignalements },
      { data: prosData },
    ] = await Promise.all([
      supabase.from('users').select('*', { count: 'exact', head: true }),
      supabase.from('activites').select('*', { count: 'exact', head: true }),
      supabase.from('participations').select('*', { count: 'exact', head: true }),
      supabase.from('users').select('*').order('created_at', { ascending: false }).limit(10),
      supabase.from('activites').select('*, users(prenom)').order('created_at', { ascending: false }).limit(10),
      supabase.from('notifications').select('*').eq('type', 'signalement').eq('lu', false).order('created_at', { ascending: false }).limit(20),
      supabase.from('users').select('*').eq('is_pro', true).order('created_at', { ascending: false }),
    ]);

    setStats({ nbUsers: nbUsers || 0, nbActivites: nbActivites || 0, nbParticipations: nbParticipations || 0 });
    setInscrits(dernierInscrits || []);
    setActivites(dernieresActivites || []);
    setSignalements(notifSignalements || []);
    setPros(prosData || []);
    setLoading(false);
  };

  const marquerLu = async (id) => {
    await supabase.from('notifications').update({ lu: true }).eq('id', id);
    setSignalements(prev => prev.filter(s => s.id !== id));
  };

  const supprimerActivite = async (id) => {
    await supabase.from('activites').delete().eq('id', id);
    setActivites(prev => prev.filter(a => a.id !== id));
  };

  const bannerUser = async (id) => {
    await supabase.from('users').update({ is_banned: true }).eq('id', id);
    alert('Utilisateur banni !');
  };

  const tabs = [
    { key: 'dashboard', label: '📊 Dashboard' },
    { key: 'inscrits', label: '👥 Inscrits' },
    { key: 'pros', label: '🎯 Animateurs' },
    { key: 'activites', label: '🌿 Activités' },
    { key: 'signalements', label: `🚨 Signalements${signalements.length > 0 ? ` (${signalements.length})` : ''}` },
  ];

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#FAFAF7' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: 12 }}>🌿</div>
        <div style={{ fontFamily: 'Fredoka One, cursive', color: '#3D9A6A' }}>Chargement admin...</div>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#FAFAF7', paddingBottom: 80 }}>

      {/* HEADER */}
      <div style={{ background: 'linear-gradient(135deg, #1C2B1E, #2D7A52)', padding: '48px 24px 24px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
          <div>
            <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.5rem', color: 'white' }}>
              <span style={{ color: '#52C289' }}>Woo</span><span style={{ color: '#FF7043' }}>ki</span> Admin
            </div>
            <div style={{ fontSize: '0.78rem', color: 'rgba(255,255,255,0.6)' }}>Dashboard de gestion</div>
          </div>
          <button onClick={() => navigate('/feed')} style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 100, padding: '8px 16px', color: 'white', fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.82rem', cursor: 'pointer' }}>
            ← Feed
          </button>
        </div>

        {/* KPIs */}
        <div style={{ display: 'flex', gap: 12 }}>
          {[
            { val: stats.nbUsers, label: 'Inscrits', icon: '👥' },
            { val: stats.nbActivites, label: 'Activités', icon: '🌿' },
            { val: stats.nbParticipations, label: 'Participations', icon: '✅' },
            { val: pros.length, label: 'Animateurs', icon: '🎯' },
          ].map((k, i) => (
            <div key={i} style={{ flex: 1, background: 'rgba(255,255,255,0.1)', borderRadius: 16, padding: '12px 8px', textAlign: 'center' }}>
              <div style={{ fontSize: '1.2rem', marginBottom: 4 }}>{k.icon}</div>
              <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.4rem', color: 'white' }}>{k.val}</div>
              <div style={{ fontSize: '0.62rem', color: 'rgba(255,255,255,0.6)' }}>{k.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* TABS */}
      <div style={{ display: 'flex', gap: 0, overflowX: 'auto', scrollbarWidth: 'none', background: 'white', borderBottom: '1px solid #EEF2EE', padding: '0 8px' }}>
        {tabs.map(t => (
          <button key={t.key} onClick={() => setActiveTab(t.key)} style={{ flexShrink: 0, padding: '14px 16px', border: 'none', background: 'transparent', fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.78rem', color: activeTab === t.key ? '#3D9A6A' : '#8A9E8D', borderBottom: activeTab === t.key ? '3px solid #3D9A6A' : '3px solid transparent', cursor: 'pointer' }}>
            {t.label}
          </button>
        ))}
      </div>

      <div style={{ padding: '20px 20px 40px' }}>

        {/* DASHBOARD */}
        {activeTab === 'dashboard' && (
          <div>
            <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.1rem', color: '#1C2B1E', marginBottom: 16 }}>Vue d'ensemble</div>
            {signalements.length > 0 && (
              <div style={{ background: '#FFF3EE', borderRadius: 16, padding: '14px 16px', marginBottom: 16, border: '2px solid #FFD5C8' }}>
                <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '0.95rem', color: '#FF7043', marginBottom: 8 }}>🚨 {signalements.length} signalement{signalements.length > 1 ? 's' : ''} en attente</div>
                <button onClick={() => setActiveTab('signalements')} style={{ padding: '8px 16px', background: '#FF7043', color: 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.82rem', cursor: 'pointer' }}>
                  Voir les signalements →
                </button>
              </div>
            )}
            {pros.filter(p => !p.documents_fournis).length > 0 && (
              <div style={{ background: '#FFF8E1', borderRadius: 16, padding: '14px 16px', marginBottom: 16, border: '2px solid #FFE082' }}>
                <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '0.95rem', color: '#FF8F00', marginBottom: 8 }}>🎯 {pros.filter(p => !p.documents_fournis).length} animateur{pros.filter(p => !p.documents_fournis).length > 1 ? 's' : ''} sans documents</div>
                <button onClick={() => setActiveTab('pros')} style={{ padding: '8px 16px', background: '#FF8F00', color: 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.82rem', cursor: 'pointer' }}>
                  Voir les animateurs →
                </button>
              </div>
            )}
            <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1rem', color: '#1C2B1E', marginBottom: 12 }}>Derniers inscrits</div>
            {inscrits.slice(0, 5).map((u, i) => (
              <div key={i} style={{ background: 'white', borderRadius: 16, padding: '12px 14px', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 12, boxShadow: '0 2px 8px rgba(28,43,30,0.06)' }}>
                <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'linear-gradient(135deg, #3D9A6A, #52C289)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontFamily: 'Fredoka One, cursive', fontSize: '0.9rem', flexShrink: 0 }}>
                  {(u.prenom || '?')[0].toUpperCase()}
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 700, fontSize: '0.88rem', color: '#1C2B1E' }}>{u.prenom || 'Anonyme'} {u.is_pro ? '🎯' : ''} {u.super_famille ? '🏆' : ''}</div>
                  <div style={{ fontSize: '0.72rem', color: '#8A9E8D' }}>{u.telephone} · {u.created_at ? new Date(u.created_at).toLocaleDateString('fr-FR') : 'Date inconnue'}</div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* INSCRITS */}
        {activeTab === 'inscrits' && (
          <div>
            <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.1rem', color: '#1C2B1E', marginBottom: 16 }}>👥 {stats.nbUsers} inscrits</div>
            {inscrits.map((u, i) => (
              <div key={i} style={{ background: 'white', borderRadius: 16, padding: '14px 16px', marginBottom: 8, boxShadow: '0 2px 8px rgba(28,43,30,0.06)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                  <div style={{ width: 38, height: 38, borderRadius: '50%', background: 'linear-gradient(135deg, #3D9A6A, #52C289)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontFamily: 'Fredoka One, cursive', fontSize: '0.9rem', flexShrink: 0 }}>
                    {(u.prenom || '?')[0].toUpperCase()}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: '0.88rem', color: '#1C2B1E' }}>
                      {u.prenom || 'Anonyme'}
                      {u.is_pro && <span style={{ background: '#FFF8E1', color: '#FF8F00', padding: '2px 8px', borderRadius: 100, fontSize: '0.65rem', fontWeight: 800, marginLeft: 6 }}>🎯 Pro</span>}
                      {u.super_famille && <span style={{ background: '#FFFBE6', color: '#FFB300', padding: '2px 8px', borderRadius: 100, fontSize: '0.65rem', fontWeight: 800, marginLeft: 6 }}>🏆 Super</span>}
                    </div>
                    <div style={{ fontSize: '0.72rem', color: '#8A9E8D' }}>{u.telephone}</div>
                  </div>
                  <div style={{ fontSize: '0.7rem', color: '#8A9E8D' }}>{u.created_at ? new Date(u.created_at).toLocaleDateString('fr-FR') : ''}</div>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={() => bannerUser(u.id)} style={{ padding: '6px 12px', background: '#FFF3EE', color: '#FF7043', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.72rem', cursor: 'pointer' }}>
                    🚫 Bannir
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ANIMATEURS PRO */}
        {activeTab === 'pros' && (
          <div>
            <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.1rem', color: '#1C2B1E', marginBottom: 8 }}>🎯 {pros.length} animateur{pros.length > 1 ? 's' : ''} inscrit{pros.length > 1 ? 's' : ''}</div>
            <div style={{ fontSize: '0.82rem', color: '#8A9E8D', marginBottom: 16 }}>Les documents sont fournis par les animateurs sous leur responsabilité.</div>

            {pros.length === 0 && (
              <div style={{ background: 'white', borderRadius: 24, padding: '32px', textAlign: 'center', boxShadow: '0 4px 20px rgba(28,43,30,0.07)' }}>
                <div style={{ fontSize: '3rem', marginBottom: 12 }}>🎯</div>
                <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1rem', color: '#1C2B1E', marginBottom: 8 }}>Pas encore d'animateurs</div>
                <div style={{ fontSize: '0.82rem', color: '#8A9E8D' }}>Lance ta pub Facebook pour en recruter !</div>
              </div>
            )}

            {pros.map((p, i) => (
              <div key={i} style={{ background: 'white', borderRadius: 20, padding: '16px', marginBottom: 12, boxShadow: '0 4px 20px rgba(28,43,30,0.07)', border: p.documents_fournis ? '2px solid #EDF7F1' : '2px solid #FFF3EE' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, marginBottom: 12 }}>
                  <div style={{ width: 44, height: 44, borderRadius: '50%', background: 'linear-gradient(135deg, #FF8F00, #FFB300)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontFamily: 'Fredoka One, cursive', fontSize: '1rem', flexShrink: 0 }}>
                    {(p.prenom || '?')[0].toUpperCase()}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                      <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1rem', color: '#1C2B1E' }}>{p.prenom}</div>
                      {p.documents_fournis
                        ? <span style={{ background: '#EDF7F1', color: '#3D9A6A', padding: '2px 8px', borderRadius: 100, fontSize: '0.65rem', fontWeight: 800 }}>📋 Documents fournis</span>
                        : <span style={{ background: '#FFF3EE', color: '#FF7043', padding: '2px 8px', borderRadius: 100, fontSize: '0.65rem', fontWeight: 800 }}>⚠️ Sans documents</span>
                      }
                    </div>
                    <div style={{ fontSize: '0.78rem', color: '#8A9E8D', marginBottom: 4 }}>{p.telephone}</div>
                    {p.specialite && <div style={{ fontSize: '0.78rem', color: '#FF8F00', fontWeight: 700 }}>🎯 {p.specialite}</div>}
                  </div>
                  <div style={{ fontSize: '0.7rem', color: '#8A9E8D' }}>{p.created_at ? new Date(p.created_at).toLocaleDateString('fr-FR') : ''}</div>
                </div>

                {p.bio && (
                  <div style={{ background: '#FAFAF7', borderRadius: 12, padding: '10px 12px', marginBottom: 12, fontSize: '0.82rem', color: '#4A6355', lineHeight: 1.6, fontStyle: 'italic' }}>
                    "{p.bio}"
                  </div>
                )}

                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
                  {p.contact_pro && (
                    <div style={{ background: '#EDF7F1', borderRadius: 12, padding: '6px 12px', fontSize: '0.78rem', color: '#3D9A6A', fontWeight: 700 }}>
                      📞 {p.contact_pro}
                    </div>
                  )}
                </div>

                {p.documents_fournis && (
                  <div style={{ background: '#EDF7F1', borderRadius: 12, padding: '10px 14px', marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span style={{ fontSize: '1.2rem' }}>📋</span>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '0.78rem', fontWeight: 700, color: '#3D9A6A' }}>Document fourni par l'animateur</div>
                      <div style={{ fontSize: '0.72rem', color: '#8A9E8D' }}>Vérifie dans Supabase Storage → photos → documents → {p.id}</div>
                    </div>
                    <button onClick={() => window.open(`https://sakhxnkfqbojzgourmua.supabase.co/storage/v1/object/public/photos/documents/${p.id}/diplome.jpg`, '_blank')}
                      style={{ padding: '6px 12px', background: '#3D9A6A', color: 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.72rem', cursor: 'pointer' }}>
                      Voir 👁️
                    </button>
                  </div>
                )}

                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={() => bannerUser(p.id)} style={{ padding: '8px 14px', background: '#FFF3EE', color: '#FF7043', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.75rem', cursor: 'pointer' }}>
                    🚫 Bannir
                  </button>
                  <button onClick={() => navigate(`/famille/${p.prenom}`)} style={{ padding: '8px 14px', background: '#EDF7F1', color: '#3D9A6A', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.75rem', cursor: 'pointer' }}>
                    👤 Voir profil
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ACTIVITÉS */}
        {activeTab === 'activites' && (
          <div>
            <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.1rem', color: '#1C2B1E', marginBottom: 16 }}>🌿 Dernières activités</div>
            {activites.map((a, i) => (
              <div key={i} style={{ background: 'white', borderRadius: 16, padding: '14px 16px', marginBottom: 8, boxShadow: '0 2px 8px rgba(28,43,30,0.06)' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                  <div style={{ width: 40, height: 40, borderRadius: 12, background: '#EDF7F1', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.2rem', flexShrink: 0 }}>{a.emoji}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 700, fontSize: '0.88rem', color: '#1C2B1E' }}>{a.titre}</div>
                    <div style={{ fontSize: '0.72rem', color: '#8A9E8D' }}>
                      {a.users?.prenom || 'Anonyme'} · {a.lieu?.split(',')[0]} · {a.date ? new Date(a.date).toLocaleDateString('fr-FR') : ''}
                      {a.is_payante && <span style={{ color: '#FF8F00', fontWeight: 700 }}> · 💰 {a.prix_enfant}€</span>}
                    </div>
                  </div>
                </div>
                <button onClick={() => supprimerActivite(a.id)} style={{ padding: '6px 12px', background: '#FFF3EE', color: '#FF7043', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.72rem', cursor: 'pointer' }}>
                  🗑️ Supprimer
                </button>
              </div>
            ))}
          </div>
        )}

        {/* SIGNALEMENTS */}
        {activeTab === 'signalements' && (
          <div>
            <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.1rem', color: '#1C2B1E', marginBottom: 16 }}>🚨 Signalements</div>
            {signalements.length === 0 && (
              <div style={{ background: 'white', borderRadius: 24, padding: '32px', textAlign: 'center', boxShadow: '0 4px 20px rgba(28,43,30,0.07)' }}>
                <div style={{ fontSize: '3rem', marginBottom: 12 }}>✅</div>
                <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1rem', color: '#3D9A6A' }}>Aucun signalement en attente</div>
              </div>
            )}
            {signalements.map((s, i) => (
              <div key={i} style={{ background: 'white', borderRadius: 16, padding: '14px 16px', marginBottom: 8, border: '2px solid #FFD5C8', boxShadow: '0 2px 8px rgba(28,43,30,0.06)' }}>
                <div style={{ fontSize: '0.82rem', color: '#1C2B1E', marginBottom: 8, lineHeight: 1.6 }}>{s.message}</div>
                <div style={{ fontSize: '0.7rem', color: '#8A9E8D', marginBottom: 10 }}>{s.created_at ? new Date(s.created_at).toLocaleDateString('fr-FR') : ''}</div>
                <button onClick={() => marquerLu(s.id)} style={{ padding: '8px 14px', background: '#EDF7F1', color: '#3D9A6A', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.78rem', cursor: 'pointer' }}>
                  ✅ Traité
                </button>
              </div>
            ))}
          </div>
        )}

      </div>
    </div>
  );
}